module.exports = __webpack_public_path__ + "img/ozel-saglik-sigortasi.1b9d4618.png";